export const DefaultUrlApi =
  process.env.NODE_ENV === "development" ||
    window.origin === "https://sana.backoffice.matican.work" ||
    window.origin === "https://sanacash.matican.work"
    ? "https://developeapitrader.sanacash.net"
    : "https://webapitrader.sanacash.net";

export const DefaultAuth =
  process.env.NODE_ENV === "development" ||
    window.origin === "https://sana.backoffice.matican.work" ||
    window.origin === "https://sanacash.matican.work"
    ? "https://developelogintest.sanacash.net/"
    : "https://identity.sanacash.net/";

export const DefaultUrlWeb = "https://sanacash.net";

export const DefaultLoginPage = "/";

export const LANDING_PAGE_URL =
  process.env.NODE_ENV === "development" ||
    window.origin === "https://sana.backoffice.matican.work" ||
    window.origin === "https://sanacash.matican.work"
    ? "http://sana.landing.matican.work"
    : "https://webtrader.sanacash.net";
